import {DetailsField} from '@/components/ui/details-atoms/DetailsAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {HelpCircleIcon} from '@/components/ui/icon/Icon'
import {Text} from '@/components/ui/text/Text'
import {Tooltip} from '@/components/ui/tooltip/Tooltip'
import {useAbsenceThreshold} from '@/features/planned-accesses/hooks/useAbsenceThreshold'
import {AssistiveRegimeEnum} from '@/features/projects/types'
import {useTranslation} from '@/translations/i18n'
import {PatientAgeRange} from '@/types'
import {useTheme} from 'styled-components'

interface PlannedAccessesThresholdDetailsProps {
    assistiveRegime: AssistiveRegimeEnum | null
    serviceType: Exclude<PatientAgeRange, 'evolutionary_age_adults'> | null
    totalInPresenceAccessesCount: number
    title?: string
}

export const PlannedAccessesThresholdDetails = ({
    assistiveRegime,
    serviceType,
    totalInPresenceAccessesCount,
    title
}: PlannedAccessesThresholdDetailsProps) => {
    const {t} = useTranslation()
    const {palette} = useTheme()

    const {selectedAbsenceThresholdPercentage, totalAbsencesAllowed, assistiveRegimeIndex} = useAbsenceThreshold({
        assistiveRegime,
        serviceType,
        totalInPresenceAccessesCount
    })

    return (
        <DetailsField>
            <Flexbox align="center" gap={2}>
                <Text size="textSm" weight="400" palette="neutral" shade="600">
                    {title ?? t('planned_accesses:absence_threshold_field_title')}
                </Text>
                <Tooltip
                    isOpenOnClickEnabled={false}
                    contentProps={{side: 'top'}}
                    variant="light"
                    content={
                        assistiveRegimeIndex == 0
                            ? t('planned_accesses:increase_threshold_tooltip')
                            : t('planned_accesses:decrease_threshold_tooltip')
                    }
                    triggerProps={{asChild: true}}
                >
                    <HelpCircleIcon size={14} color={palette.neutral[700]} />
                </Tooltip>
            </Flexbox>
            <Text size="textSm" weight="500">
                {totalAbsencesAllowed ?? '-'}{' '}
                <Text weight={400} render="span" palette="neutral" shade="500">
                    ({selectedAbsenceThresholdPercentage}%)
                </Text>
            </Text>
        </DetailsField>
    )
}
